<template>
  <div>
    <div class="saas-page-head">
      <div class="saas-rounded-shape saas-rounded-shape__default-left-1"></div>
      <div class="saas-rounded-shape saas-rounded-shape__default-left-2"></div>
      <div class="saas-rounded-shape saas-rounded-shape__default-left-3"></div>
      <div class="saas-rounded-shape saas-rounded-shape__default-right-1"></div>
      <div class="saas-rounded-shape saas-rounded-shape__default-right-2"></div>
      <h1 class="saas-page-head__title">Let's <strong>connect</strong></h1>
      <p class="saas-page-head__description">We're ready to chat.</p>
      <div class="saas-contact__buttons">
        <a
          href="https://community.baserow.io/"
          target="_blank"
          class="saas-contact__button"
        >
          <i class="iconoir-arrow-right saas-contact__button-hover"></i>
          <div class="saas-contact__button-icon">
            <i class="iconoir-group"></i>
          </div>
          <div class="saas-contact__button-title">Ask the community</div>
          <div class="saas-contact__button-description">
            Get fast answers to your questions, learn how-tos, and advice from
            the Baserow users.
          </div>
        </a>
        <nuxt-link :to="{ name: 'contact-sales' }" class="saas-contact__button">
          <i class="iconoir-arrow-right saas-contact__button-hover"></i>
          <div class="saas-contact__button-icon">
            <i class="iconoir-large-suitcase"></i>
          </div>
          <div class="saas-contact__button-title">Ask sales</div>
          <div class="saas-contact__button-description">
            Get a demo, discuss a partnership, and explore Enterprise pricing.
          </div>
        </nuxt-link>
      </div>
      <div class="saas-contact__connected-container">
        <div class="saas-contact__connected-wrapper">
          <div class="saas-contact__connected">
            <div class="saas-contact__text">Stay connected on social:</div>
            <div class="saas-contact__actions">
              <Button
                size="large"
                tag="a"
                type="secondary"
                icon="baserow-icon-twitter"
                href="https://twitter.com/baserow"
                target="_blank"
              ></Button>
              <Button
                size="large"
                tag="a"
                type="secondary"
                icon="baserow-icon-linkedin"
                href="https://www.linkedin.com/company/baserow/"
                target="_blank"
              ></Button>
              <Button
                size="large"
                tag="a"
                type="secondary"
                icon="iconoir-youtube"
                href="https://www.youtube.com/@baserow/videos"
                target="_blank"
              ></Button>
              <Button
                size="large"
                tag="a"
                type="secondary"
                icon="baserow-icon-reddit"
                href="https://www.reddit.com/r/baserow/"
                target="_blank"
              ></Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterJoin></FooterJoin>
  </div>
</template>

<script>
import FooterJoin from '@saas/components/footer/FooterJoin'

export default {
  components: { FooterJoin },
  layout: 'saas',
}
</script>
